import { IWedding, IWedding_Website } from '@bridebook/models/source/models/Weddings.types';
import { IWeddingEvent } from '@bridebook/models/source/models/Weddings/Events.types';
import { IPhoto } from '@bridebook/models/source/models/Suppliers/Photos.types';
import { BBOrCustomSupplier } from '@bridebook/web/lib/supplier/hooks/query/use-supplier';
import { isVenueSection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import { createContext, useContext } from 'react';

export type PhotosBySupplier = { supplierId: string; photos: IPhoto[] }[];

export const WeddingWebsiteDataContext = createContext<{
  website: IWedding_Website;
  wedding: {
    date: IWedding['date'];
    partners: IWedding['partners'];
  };
  events: IWeddingEvent[];
  suppliers: BBOrCustomSupplier[];
  photosBySupplier?: PhotosBySupplier;
  isGuestView?: boolean;
} | null>(null);

export const useWeddingWebsiteData = () => {
  const context = useContext(WeddingWebsiteDataContext);

  if (!context) {
    throw new Error(
      'useWeddingWebsiteData must be used within a WeddingWebsiteDataContext.Provider.',
    );
  }

  const venueSupplierId = context.website.sections.find(isVenueSection)?.data.supplier;
  const mainSupplier = venueSupplierId
    ? context.suppliers.find((supplier) => supplier.id === venueSupplierId)
    : undefined;

  return {
    ...context,
    mainSupplier,
    mainSupplierPhotos: venueSupplierId
      ? context.photosBySupplier?.find((p) => p.supplierId === venueSupplierId)?.photos
      : undefined,
  };
};
